/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "0b05ca218a33a3ecb80e8f0a587365fc5df4477f";
